import { render, staticRenderFns } from "./IdentityManagerModalEditComponent.vue?vue&type=template&id=aaed010c"
import script from "./IdentityManagerModalEditComponent.vue?vue&type=script&lang=js"
export * from "./IdentityManagerModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports